// extracted by mini-css-extract-plugin
export default {"burgerIcon":"tyXt3HKxxJABrps6PSr3","scrolled":"h1GbGbaNdYQ8IiRs3xq7","burgerLine":"A9__7nLZuUj1HpQUyQF7"};